module.exports = __webpack_public_path__ + "img/motorcycle-back.e020bb45.jpg";